export interface AssistantTextSegment {
  text: string;
  isBold: boolean;
  isItalic: boolean;
}

export type AssistantTextBlock =
  | { kind: 'paragraph'; segments: AssistantTextSegment[] }
  | { kind: 'orderedList'; items: AssistantTextSegment[][] }
  | { kind: 'bulletList'; items: AssistantTextSegment[][] };

const ORDERED_ITEM_PATTERN = /^\s*\d+[.)]\s+(.*)$/;
const BULLET_ITEM_PATTERN = /^\s*[-*•]\s+(.*)$/;
const INLINE_PATTERN = /(\*\*[^*]+\*\*|\*[^*]+\*)/g;

export function parseInlineSegments(line: string): AssistantTextSegment[] {
  return line
    .split(INLINE_PATTERN)
    .filter(function isNotEmpty(part) {
      return part.length > 0;
    })
    .map(function toSegment(part) {
      if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
        return { text: part.slice(2, -2), isBold: true, isItalic: false };
      }
      if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
        return { text: part.slice(1, -1), isBold: false, isItalic: true };
      }
      return { text: part, isBold: false, isItalic: false };
    });
}

export function formatAssistantText(text: string): AssistantTextBlock[] {
  const blocks: AssistantTextBlock[] = [];
  text.split('\n').forEach(function readLine(line) {
    const orderedMatch = line.match(ORDERED_ITEM_PATTERN);
    const bulletMatch = line.match(BULLET_ITEM_PATTERN);
    const previousBlock = blocks[blocks.length - 1];
    if (orderedMatch !== null) {
      const segments = parseInlineSegments(orderedMatch[1] === undefined ? '' : orderedMatch[1]);
      if (previousBlock !== undefined && previousBlock.kind === 'orderedList') {
        previousBlock.items.push(segments);
      } else {
        blocks.push({ kind: 'orderedList', items: [segments] });
      }
      return;
    }
    if (bulletMatch !== null) {
      const segments = parseInlineSegments(bulletMatch[1] === undefined ? '' : bulletMatch[1]);
      if (previousBlock !== undefined && previousBlock.kind === 'bulletList') {
        previousBlock.items.push(segments);
      } else {
        blocks.push({ kind: 'bulletList', items: [segments] });
      }
      return;
    }
    if (line.trim().length > 0) {
      blocks.push({ kind: 'paragraph', segments: parseInlineSegments(line) });
    }
  });
  return blocks;
}
